export default "__VITE_ASSET__7088c217__"